/*
document.addEventListener('infiniteoptions.productBundleAdd', function(response) {
    const elementCheck = setInterval(() => {
        const infiniteOptionGroups = document.querySelectorAll('#infiniteoptions-container > div');
        const infiniteOptionGroupsFilter = Array.prototype.slice.call(infiniteOptionGroups).filter(infiniteOptionGroups => window.getComputedStyle(infiniteOptionGroups).display !== "none");

        if (infiniteOptionGroupsFilter.length != 0) {
            for (let i = 0; i < infiniteOptionGroupsFilter.length; i++) {
                const infiniteOptionGroup = infiniteOptionGroupsFilter[i];
                const groupTitle = infiniteOptionGroup.querySelector('.spb-label-tooltip label');
                const option_number = i + 1;

                if (!groupTitle.querySelector('.label-number') && groupTitle.innerHTML != '') {
                    // Step ${option_number} of ${infiniteOptionGroupsFilter.length}
                    groupTitle.innerHTML = `<span class="label-number">${option_number}.</span> ${groupTitle.innerHTML}`
                }
            }

            clearInterval(elementCheck);
        }
    }, 500);
})
*/




if (window.Shoppad) {
  window.Shoppad.apps.infiniteoptions.ready = function() {
    for(let input of document.querySelectorAll(['.infinite_swatches_colour .spb-productoptionswatchwrapper input[type="radio"]', '.infinite_swatches_colour .spb-productoptionswatchwrapper input[type="checkbox"]'])){
      input.parentNode.setAttribute("colour", input.value);
      if(input.parentNode.getAttribute("colour").toLowerCase() == 'remove'){
        input.addEventListener('change', function(event){
          event.preventDefault;
          let colourContainer = input.parentElement.parentElement;
          console.log(colourContainer);
          for(const colour of colourContainer.querySelectorAll(['input[type="radio"]', 'input[type="checkbox"]'])){
            colour.checked=false;
          };
        });
      };
    };
  };
};

function onTidioChatApiReadyChangeZIndex() {
  (function() {
    const tidioChatIframe = document.getElementById('tidio-chat-iframe');
    if (tidioChatIframe) {
      tidioChatIframe.style.zIndex = '95';
    }
  })();
}
if (window.tidioChatApi) {
  window.tidioChatApi.on("ready", onTidioChatApiReadyChangeZIndex);
} else {
  document.addEventListener("tidioChat-ready", onTidioChatApiReadyChangeZIndex);
}

// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

// Define beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe('appLoad', function(event) {
    const labels = document.querySelectorAll('.spb-label-tooltip label');
    for (const label of labels) {
      const label_text = label.textContent.split(' (')[0];
      label.textContent = label_text;
    }
  });

  subscribe('fieldChange', function(event) {
    var inputFields = document.querySelectorAll(['#infiniteoptions-container input[type="text"]', '#infiniteoptions-container textarea']);
    if (inputFields.length) {
      for (const inputField of inputFields) {
        let inputFieldPlaceholder = inputField.getAttribute('placeholder');
        if(inputFieldPlaceholder) {
          inputFieldPlaceholder = inputFieldPlaceholder.toLowerCase();
          if (inputFieldPlaceholder.includes('word') || inputFieldPlaceholder.includes('words')) {
            let inputFieldWords = inputFieldPlaceholder.split(' word')[0];
            inputFieldWords = parseInt(inputFieldWords.split(' ').pop());

            // Attach an input event listener to the input field
            inputField.addEventListener('input', function() {
              var words = inputField.value.trim().split(/\s+/);
              if (words.length > inputFieldWords) {
                // Trim the excess words
                words = words.slice(0, inputFieldWords);
                inputField.value = words.join(' ');
              }
            });
          }
        }
      }
    }
  });
};


jQuery('document').ready(function($){

  // $('body').on('click', '.header--cart .header--cart-toggle', function(e) {
  //   e.stopPropagation();
  //   alert('sdkjvfh');
  //   window.location.href = 'https://www.amysbakehouse.co.uk/cart';
  // });

  var wordLen = 5,
	len; // Maximum word length
  $('.product-page--block').on('keydown', 'input[name="properties[Iced Message Text]"]', function(event) {	
    len = $('.product-page--block input[name="properties[Iced Message Text]"]').val().split(/[\s]+/);
    if (len.length > wordLen) { 
      if ( event.keyCode == 46 || event.keyCode == 8 ) {// Allow backspace and delete buttons
      } else if (event.keyCode < 48 || event.keyCode > 57 ) {//all other buttons
        event.preventDefault();
      }
    }
  });
  
  $('.template--cart .popup_outer .cart_upsell_wrapper').slick({
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 3500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  setTimeout(function() {
  $('.options-container .product-options-watch-wrapper span, .options-container ul.dropdown-options-list li.dropdown-option').on('click', function(){
      $('button.product-buy-buttons--cta').attr('disabled', false);
    });
    $('.options-container select.pb-productdescfont').on('change', function(){
      $('button.product-buy-buttons--cta').attr('disabled', false);
    });
    $('.options-container input').on('keypress', function(){
      $('button.product-buy-buttons--cta').attr('disabled', false);
    });
  }, 5000);
   
})